import { z } from 'zod';

export const FORM_SCHEMA = z.object({
  id: z.string(),
  is_active: z.boolean({ required_error: 'Please select an option' }),
  return_fee: z.coerce.number().min(0, 'Fee must be atleast 0'),
  exchange_fee: z.coerce.number().min(0, 'Fee must be atleast 0')
});

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  id: '',
  is_active: false,
  return_fee: '',
  exchange_fee: ''
};
